import { PseudoBox, Box } from '@chakra-ui/core'
import { IPop } from 'constants/interfaces'
import { X } from 'lucide-react'

import PopAvatar from '../PopAvatar'
import React from 'react'

interface IProps {
  aiPop: IPop
  onClose: () => void
  editMode?: boolean
}

export const ModalHeaderWithClose = ({ aiPop, onClose, editMode = false }: IProps) => {
  return (
    <Box position="relative" display="flex" alignItems="center" justifyContent="center" width="100%">
      <PseudoBox
        pointerEvents={editMode ? 'none' : 'auto'}
        opacity={editMode ? 0.5 : 1}
        cursor={editMode ? 'not-allowed' : 'pointer'}
        onClick={onClose}
        position="absolute"
        borderRadius="50%"
        backgroundColor="white"
        left="-55px"
        top="-10px"
        transform="translateY(-50%)"
        color="black"
        zIndex={10}
        fontSize="24px"
        fontWeight="bold"
        minW="auto"
        h="35px"
        w="35px"
        p="8px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <X size={24} />
      </PseudoBox>

      <PopAvatar {...aiPop} width="170px" height="170px" />
    </Box>
  )
}
